// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"245":"ccdcc64c","270":"aa022546","353":"3a919771","453":"0b84106f","495":"8106de82","700":"c4a1e58e","835":"9117e037"}[chunkId] + ".chunk.js";
};